import styled, { css } from 'styled-components';

import { Box } from '../../base';

export const GridContainer = styled(Box)<{
  $columns: number | string;
  $innerBorder: boolean;
  gap: number;
}>`
  display: grid;
  grid-gap: ${({ gap, theme }) => theme.mosaiq.spacing(gap)}px;
  grid-template-columns: ${({ $columns }) =>
    typeof $columns === 'string' ? $columns : `repeat(${$columns}, 1fr)`};

  ${({ $innerBorder }) =>
    $innerBorder &&
    css`
      border: 1px solid ${({ theme }) => theme.mosaiq.colors.grey60};

      & > *:not(*:last-child) {
        border-right: 1px solid ${({ theme }) => theme.mosaiq.colors.grey60};
      }
    `}
`;
